import React from "react";
import PropTypes from "prop-types";
import { controlPropTypes } from "../formhelpers";
import RecordGrid from "../BaseControls/RecordGrid/RecordGrid";

export default class Summarysection extends React.Component {
    render() {
        const {descriptor} = this.props;
        return (
            <div className="form-item full-width">
                <div
                    id={descriptor.id}
                    className={`control-container-${descriptor.key} composition-field full-width react-control`}
                    data-control-type={descriptor.control}
                    data-shortname={descriptor.key}
                >
                    <RecordGrid {...this.props} />
                </div>
            </div>

        );
    }
}

Summarysection.propTypes = {
    ...controlPropTypes(null, false),
    onCommitChange: PropTypes.func

};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/CompositionField/summarysection.js